export const drawImageOnCanvas = async (
    canvasRef: HTMLCanvasElement,
    imageRef: HTMLImageElement,
): Promise<true> => {
    return new Promise((resolve, reject) => {
        if (imageRef.height === 0 || imageRef.width === 0) {
            reject(new Error('Image ref invalid'));
            return;
        }

        canvasRef.height = imageRef.height;
        canvasRef.width = imageRef.width;

        // Create an image element in the canvas
        const context = canvasRef.getContext('2d');
        const imageLoad = new Image();
        imageLoad.src = imageRef.currentSrc || imageRef.src;
        // Set crossOrigin to allow canvas to read the image (only on local as it's using same origin when deployed)
        if (import.meta.env.LOCAL_DEVELOPMENT) {
            imageLoad.setAttribute('crossOrigin', '');
        }
        imageLoad.onload = () => {
            context?.drawImage(imageRef, 0, 0, imageRef.width, imageRef.height);
            resolve(true);
        };
    });
};
